import { Observable } from "rxjs";
import { config } from "../../config/config";
import { utilService } from "../utils";

/**
 * Api services for email logs component
 */
export const emailLogsService = {
  getEmailLogs,
};

function getEmailLogs(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.email_statistics + data.params, {
      method: "GET",
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
        // return result.responceObject.records
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}
